import { Logo } from "./Logo";
import { ShieldCheck, Zap, RotateCcw } from "lucide-react";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#07090e]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div>
          <Logo />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            Publishing calm for the modern mind. One program, perfected — The 7-Night Sleep Reset.
          </p>
          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-xs text-slate-500">
            <span className="flex items-center gap-1.5"><Zap className="h-3.5 w-3.5 text-cyan-400" /> Instant download</span>
            <span className="flex items-center gap-1.5"><RotateCcw className="h-3.5 w-3.5 text-cyan-400" /> 30-night guarantee</span>
            <span className="flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5 text-cyan-400" /> Secure Stripe checkout</span>
          </div>
        </div>
      </div>
      <div className="pointer-events-none select-none overflow-hidden">
        <p className="font-display -mb-8 text-center text-[18vw] font-extrabold leading-none tracking-tight text-white/[0.03] lg:-mb-16">
          ASTRA
        </p>
      </div>
      <div className="border-t border-white/5 py-6 pb-24 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600 sm:pb-6">
        © 2026 Astra Press · All rights reserved
      </div>
    </footer>
  );
}
